import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MapContext } from '@/state/context/MapContext';
import VectorSource from 'ol/source/Vector';
import { PreferencesState, RootState } from '@/state';

const useClusterConfig = (
    source: VectorSource
): { distance: number; source: VectorSource } => {
    const { map } = useContext(MapContext);
    const prefs = useSelector<RootState, PreferencesState>(state => state.preferences);
    const zoom = map ? map.getView().getZoom() : undefined;
    const distance = zoom !== undefined && zoom >= 15 && prefs.disableClusters ? 15 : 50;

    return useMemo(() => ({ distance, source }), [distance, source]);
};

export default useClusterConfig;
